<template>
  <md-list-item
    class="md-inset vdl-list-checkbox"
    @click="toggleCheck"
    :class="{ 'right-align': rightAlign, 'md-disabled': disabled }"
  >
    <md-icon v-if="type === 'checkbox'" v-bind:class="getIconClass" :mdSvg="getIcon" />
    <slot v-if="type === 'checkbox'" class="md-list-text-container"> </slot>
    <md-radio v-else v-model="inputValue.id" :id="id" :md-value="vdlValue.id !== undefined ? vdlValue.id : ''">
      <slot class="md-list-text-container"> </slot>
    </md-radio>
  </md-list-item>
</template>

<script>
import { mdiCheckboxBlankOutline, mdiCheckboxMarked } from '@mdi/js';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'vdl-list-checkbox',
  props: {
    id: String,
    name: String,
    modelValue: [String, Number, Array, Object],
    disabled: Boolean,
    type: {
      type: String,
      default: 'checkbox',
    },
    vdlValue: {
      required: true,
    },
    rightAlign: {
      default: false,
    },
  },
  computed: {
    inputValue: {
      get() {
        return (this.modelValue !== undefined && this.modelValue) || (this.type === 'radio' ? '' : []);
      },
      set(newValue) {
        this.toggleCheck();
      },
    },
    getIcon() {
      return this.checked ? mdiCheckboxMarked : mdiCheckboxBlankOutline;
    },
    getIconClass() {
      return this.checked ? 'md-primary' : '';
    },
    checked() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.vdlValue) > -1;
      }
      return this.inputValue === this.vdlValue;
    },
  },
  methods: {
    toggleCheck(val) {
      if (!this.disabled) {
        let value = this.vdlValue;

        if (Array.isArray(this.inputValue)) {
          value = this.inputValue;
          const index = value.indexOf(this.vdlValue);

          if (index > -1) {
            value.splice(index, 1);
          } else {
            value.push(this.vdlValue);
          }
        }
        // this.$emit('change', 'value');
        this.$emit('update:modelValue', value);
      }
    },
  },
});
</script>

<style lang="scss">
.vdl-list-checkbox {
  cursor: pointer;
  .md-list-item-container {
    > .md-icon:first-child,
    > .md-radio {
      margin-right: 16px;
    }
    .md-radio-container {
      min-width: 20px;
    }
  }

  &.right-align {
    .md-list-item-container {
      flex-flow: row-reverse;
      > .md-icon,
      > .md-radio {
        margin-right: 0px;
      }
    }
  }
  &.checkbox.md-list-item.md-inset {
    .md-list-item-container {
      padding-left: 0px;
    }
  }
}
</style>
